import { HttpErrorResponse } from "@angular/common/http";
import { AddLoginHistory, EventHistoryRecords, EventTypes } from "src/app/_models/EventDto";

export interface EventHistoryState {
  allEventTypes: EventTypes[];
  allEventTypesLoader: boolean;
  allEventTypesError: HttpErrorResponse;

  eventHistoryRecords: EventHistoryRecords[];
  eventHistoryLoader: boolean;
  eventHistoryError: HttpErrorResponse;

  addLoginHistory: AddLoginHistory;
  addLoginHistoryLoader: boolean;
  addLoginHistoryError: HttpErrorResponse;

  currentPageNumber: number;
  currentPageNumberLoader: boolean;
  currentPageNumberError: HttpErrorResponse;

  updateEventHistoryTable: boolean;
  updateEventHistoryTableLoader: boolean;
  updateEventHistoryTableError: HttpErrorResponse;

  eventHistoryRecordsLength: number;
  eventHistoryRecordsLengthLoader: boolean;
  eventHistoryRecordsLengthError: HttpErrorResponse;
}

export const initialEventHistoryState: EventHistoryState = {
  allEventTypes: null,
  allEventTypesLoader: false,
  allEventTypesError: null,

  eventHistoryRecords: [],
  eventHistoryLoader: false,
  eventHistoryError: null,

  addLoginHistory: null,
  addLoginHistoryLoader: false,
  addLoginHistoryError: null,

  currentPageNumber: 0,
  currentPageNumberLoader: false,
  currentPageNumberError: null,
  
  updateEventHistoryTable: null,
  updateEventHistoryTableLoader: false,
  updateEventHistoryTableError: null,

  eventHistoryRecordsLength: 0,
  eventHistoryRecordsLengthLoader: false,
  eventHistoryRecordsLengthError: null,
}